import React, { useState, useEffect } from "react";
import Verification from "../../../components/Verification/Verification";
import { verification } from "../../../api/api";
import { useParams } from "react-router-dom";
import loader from "../../../assets/images/loader.gif";
import "./VerificationStatus.css";

export function VerificationStatus() {
  const { id } = useParams();
  const [verificationStatus, setVerificationStatus] = useState(false);
  const [loading, setLoading] = useState(false);

  const verify = () => {
    setLoading(true);
    verification(id)
      .then((res) => {
        if (
          res.data.code === 200 &&
          res.data.message ===
            "Your account is activated successfully.! Please login"
        )
          setVerificationStatus(true);
        else setVerificationStatus(false);

        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    verify();
  }, [verificationStatus]);

  return (
    <div>
      {loading ? (
        <div className="align-center align-center-verificationstatus">
          <img src={loader} alt="loading..." className="loader" />
        </div>
      ) : (
        <Verification success={verificationStatus} />
      )}
    </div>
  );
}
